import {ID} from '~/lib/model';

export const paymentsLinks = {
    payments: (sellerId?: ID) => sellerId ? `/payments?sellerId=${sellerId}` : '/payments',
    transactionHistory: (sellerId?: ID) => sellerId ? `/payments-transaction-history?sellerIds=${sellerId}` : '/payments-transaction-history',
    prePayments: (sellerId?: ID) => sellerId ? `/scheduled?sellerIds=${sellerId}` : '/scheduled',
    paymentsTrolley: () => '/payments-trolley',
};

export const getSellerId = (search: string): ID => {
    const rawSellerId = new URLSearchParams(search).get('sellerId');
    return rawSellerId ? Number.parseInt(rawSellerId, 10) : null;
};
